import { render, staticRenderFns } from "./side-menu-item.vue?vue&type=template&id=cd1a9532&scoped=true&"
import script from "./side-menu-item.vue?vue&type=script&lang=js&"
export * from "./side-menu-item.vue?vue&type=script&lang=js&"
import style0 from "./side-menu-item.vue?vue&type=style&index=0&id=cd1a9532&lang=less&scoped=true&"
import style1 from "./side-menu-item.vue?vue&type=style&index=1&id=cd1a9532&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd1a9532",
  null
  
)

export default component.exports